(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvEntityLinkedSingle', drvEntityLinkedSingle);

    /**
     * @ngdoc directive
     * @name drvEntityLinkedSingle
     * @description Selection control for a single linked entity.
     *
     * @param {Number} value/ngModel - Id of the linked entity
     * @param {Object} field - The field definition from the entity template
     * @param {Object} entityTemplate - Entity template used to populate the icon and icon colour.
     */
    function drvEntityLinkedSingle() {
        return {
            templateUrl: 'app/entity-linked-single.tmpl.html',
            scope: {},
            controller: drvEntityLinkedSingleCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                value: '=ngModel',
                field: '=',
                entityTemplate: '<?'
            }
        };
    }

    drvEntityLinkedSingleCtrl.$inject = ['EntitiesService', 'DialogService'];

    function drvEntityLinkedSingleCtrl(EntitiesService, DialogService) {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.availableEntities = [];
        drvCtrl.getInputLabel = getInputLabel;
        drvCtrl.loadAvailableEntities = loadAvailableEntities;

        activate();

        function activate() {
            if (!angular.isUndefined(drvCtrl.field) && !angular.isUndefined(drvCtrl.field.EntityTemplateId) &&
                drvCtrl.field.EntityTemplateId !== null && drvCtrl.field.EntityTemplateId !== '') {
                drvCtrl.loadAvailableEntities(drvCtrl.field.EntityTemplateId);
            }
        }

        function loadAvailableEntities(templateId) {
            EntitiesService.query({
                entityTemplateId: templateId,
                skipSecurity: true,
                previewTextOnly: true
            })
                .then(getEntitiesOk, getEntitiesError);

            function getEntitiesOk(data) {
                drvCtrl.entities = data.Entities;

                loadSelectedEntity();
            }

            function getEntitiesError(response) {
                DialogService.error('Error fetching Entities', response);
            }
        }

        function getInputLabel() {
            var result = '';

            if (!angular.isUndefined(drvCtrl.field) && !angular.isUndefined(drvCtrl.field.Name) && drvCtrl.field.Name !== null) {
                result = drvCtrl.field.Name;
            }

            return result;
        }

        function loadSelectedEntity() {
            if (!_.isNil(drvCtrl.value) && !_.some(drvCtrl.entities, function(entity) { return entity.Id === drvCtrl.value; })) {
                EntitiesService.getPreviewText(drvCtrl.value)
                    .then(loadSelectedEntityOk, loadSelectedEntityError);
            }
        }

        function loadSelectedEntityOk(data) {
            drvCtrl.entities.push(data);
        }

        function loadSelectedEntityError(response) {
            DialogService.error('Error fetching Entities', response);
        }
    }
})();
